
// storage pattern

//  /{bucket}/{teamId}/{domain}/{path}/{filename}

// Storage paths  - {domain}/{path}
export const LIST_IMPORT_PATH = 'import/list'
export const LABEL_UPLOAD = 'Upload_'
export const HEADER_ROW_INDEX = 0
